// API Configuration
const API_BASE_URL = 'https://ccc4cs.choicegroup.in/api';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  AUTH: `${API_BASE_URL}/auth.php`,
  
  // ✅ NEW: Modules API
  MODULES: `${API_BASE_URL}/modules.php`,
  
  // User Management
  USERS: `${API_BASE_URL}/users.php`,
  USER_PERMISSIONS: `${API_BASE_URL}/users.php?type=permissions`,
  APPROVERS: `${API_BASE_URL}/users.php?type=approvers`,
  
  // Inventory Management
  INVENTORY: `${API_BASE_URL}/inventory.php`,
  BULK_DELETE: `${API_BASE_URL}/bulk_delete.php`,
  EXPORT_DATA: `${API_BASE_URL}/export_data.php`,
  IMPORT_DATA: `${API_BASE_URL}/import_data.php`,
  CHANGE_STATUS: `${API_BASE_URL}/change_status.php`,
  
  // Approval System
  APPROVALS: `${API_BASE_URL}/approvals.php`,
  AUDIT_TRAIL: `${API_BASE_URL}/audit_trail.php`,
  
  // Change Logs
  CHANGE_LOG: `${API_BASE_URL}/change_log.php`,
  
  // Repack Operations
  REPACK_OUT: `${API_BASE_URL}/repack_out.php`,
  
  // Shipments
  SHIPMENTS: `${API_BASE_URL}/shipments.php`,
  
  // QC Samples
  QC_SAMPLES: `${API_BASE_URL}/qc_samples.php`,
  
  // Reports
  CONSOLIDATED_SUMMARY: `${API_BASE_URL}/consolidated_summary.php`,
  DAILY_SUMMARY: `${API_BASE_URL}/daily_summary.php`,
  
  // Analytics
  ANALYTICS: `${API_BASE_URL}/analytics.php`,
 
  // ERP Validation
  ERP_VALIDATION: `${API_BASE_URL}/erp_validation.php`,
  
  // DPR Validation
  DPR_VALIDATION: `${API_BASE_URL}/dpr_validation.php`,
  
  // Shipment Planning
  SHIPMENT_PLANNING: `${API_BASE_URL}/shipment_planning.php`,
  
  // Password Management
  PASSWORD_RESET: `${API_BASE_URL}/password_reset.php`,
  
  // Dashboard Permissions
  DASHBOARD_PERMISSIONS: `${API_BASE_URL}/dashboard_permissions.php`,
  
  // Label Printing
  PRINT_LABELS: `${API_BASE_URL}/print-labels.php`,
  
  // ✅ Stock Report
  STOCK_REPORT: `${API_BASE_URL}/stock_report.php`,

  // ✅ User & Access Management
  USER_ACCESS_MGMT: `${API_BASE_URL}/user_management_api.php`
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  INCHARGE: 'incharge',
  SUPERVISOR: 'supervisor',
  FACTORY_HEAD: 'factory_head',
  FACTORY_MANAGER: 'factory_manager',
  DEPARTMENT_HEAD: 'department_head',
  MANAGING_DIRECTOR: 'managing_director',
  VIEWER: 'viewer'
};

// Role Permissions
export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: {
    canEdit: true,
    canDelete: true,
    canImport: true,
    canExport: true,
    canApprove: true,
    canManageUsers: true
  },
  [USER_ROLES.INCHARGE]: {
    canEdit: true,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: false,
    canManageUsers: false
  },
  [USER_ROLES.SUPERVISOR]: {
    canEdit: true,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: false,
    canManageUsers: false
  },
  [USER_ROLES.FACTORY_HEAD]: {
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: true,
    canManageUsers: false
  },
  [USER_ROLES.FACTORY_MANAGER]: {
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: true,
    canManageUsers: false
  },
  [USER_ROLES.DEPARTMENT_HEAD]: {
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: true,
    canManageUsers: false
  },
  [USER_ROLES.MANAGING_DIRECTOR]: {
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: false,
    canManageUsers: false
  },
  [USER_ROLES.VIEWER]: {
    canEdit: false,
    canDelete: false,
    canImport: false,
    canExport: true,
    canApprove: false,
    canManageUsers: false
  }
};

// Dashboard Permissions by Role
export const DEFAULT_DASHBOARD_PERMISSIONS = {
  [USER_ROLES.ADMIN]: [
    'daily_inventory',
    'repack_out',
    'shipments',
    'qc_samples',
    'shipment_planning',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'approval_requests',
    'password_resets',
    'user_management',
    'change_log',
    'audit_trail',
    'erp_validation',
    'dpr_validation',
    'stock_report'
  ],
  [USER_ROLES.INCHARGE]: [
    'daily_inventory',
    'repack_out',
    'shipments',
    'qc_samples',
    'shipment_planning',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'stock_report'
  ],
  [USER_ROLES.SUPERVISOR]: [
    'daily_inventory',
    'repack_out',
    'shipments',
    'qc_samples',
    'shipment_planning',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'stock_report'
  ],
  [USER_ROLES.FACTORY_HEAD]: [
    'daily_inventory',
    'repack_out',
    'shipments',
    'qc_samples',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'approval_requests',
    'audit_trail',
    'stock_report'
  ],
  [USER_ROLES.FACTORY_MANAGER]: [
    'daily_inventory',
    'repack_out',
    'shipments',
    'qc_samples',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'approval_requests',
    'audit_trail',
    'stock_report'
  ],
  [USER_ROLES.DEPARTMENT_HEAD]: [
    'daily_inventory',
    'repack_out',
    'shipments',
    'qc_samples',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'approval_requests',
    'audit_trail',
    'stock_report'
  ],
  [USER_ROLES.MANAGING_DIRECTOR]: [
    'daily_inventory',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'stock_report'
  ],
  [USER_ROLES.VIEWER]: [
    'daily_inventory',
    'consolidated_summary',
    'daily_summary',
    'analytics',
    'stock_report'
  ]
};

// Approval Priority Levels
export const APPROVAL_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
};

// Approval Status
export const APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Action Types for Audit Trail
export const ACTION_TYPES = {
  STATUS_CHANGE: 'status_change',
  DATA_EDIT: 'data_edit',
  DATA_DELETE: 'data_delete',
  PERMISSION_CHANGE: 'permission_change',
  OTHER: 'other'
};

// Application Settings
export const APP_SETTINGS = {
  APP_NAME: 'Warehouse Inventory Management',
  VERSION: '2.0.0',
  DEFAULT_ROWS_PER_PAGE: 50,
  MAX_EXPORT_ROWS: 10000,
  SESSION_TIMEOUT: 3600000, // 1 hour in milliseconds
  PASSWORD_MIN_LENGTH: 6
};

// Date Format
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// Export file types
export const EXPORT_TYPES = {
  CSV: 'csv',
  EXCEL: 'xlsx',
  PDF: 'pdf'
};

// Status Options - All statuses in the system
export const STATUS_OPTIONS = [
  'PRODUCED',
  'REPACK-IN',
  'REPACK-OUT',
  'RE-PRINTING',
  'RE-PROCESS',
  'ONLINE MIX',
  'SHIPPED',
  'EXCESS-RETURNED',
  'FCL EXCESS'
];

// Add Entry Modal Status Options - Available when adding new entries
export const ADD_ENTRY_STATUS_OPTIONS = [
  'PRODUCED',
  'REPACK-IN',
  'RE-PRINTING',
  'RE-PROCESS'
];

// Repack Dashboard Statuses - Statuses shown in Repack-Out Dashboard
export const REPACK_DASHBOARD_STATUSES = [
  'REPACK-OUT',
  'RE-PRINTING',
  'RE-PROCESS',
  'ONLINE MIX'
];

// Change Status Modal Options - Available options when changing status from Daily Inventory
export const CHANGE_STATUS_OPTIONS = [
  'REPACK-OUT',
  'RE-PRINTING',
  'RE-PROCESS',
  'ONLINE MIX'
];

// Daily Inventory Status Colors - Color configurations for all statuses in Daily Inventory
export const DAILY_INVENTORY_STATUS_COLORS = {
  'PRODUCED': {
    background: '#4caf50',
    color: '#ffffff',
    chipColor: 'success',
    borderColor: '#2e7d32'
  },
  'REPACK-IN': {
    background: '#2196f3',
    color: '#ffffff',
    chipColor: 'info',
    borderColor: '#1565c0'
  },
  'REPACK-OUT': {
    background: '#ed6c02',
    color: '#ffffff',
    chipColor: 'warning',
    borderColor: '#e65100'
  },
  'RE-PRINTING': {
    background: '#9c27b0',
    color: '#ffffff',
    chipColor: 'secondary',
    borderColor: '#7b1fa2'
  },
  'RE-PROCESS': {
    background: '#d32f2f',
    color: '#ffffff',
    chipColor: 'error',
    borderColor: '#c62828'
  },
  'ONLINE MIX': {
    background: '#00897b',
    color: '#ffffff',
    chipColor: 'info',
    borderColor: '#00695c'
  },
  'FCL EXCESS': {
    background: '#ff9800',
    color: '#000000',
    chipColor: 'warning',
    borderColor: '#f57c00'
  },
  'EXCESS-RETURNED': {
    background: '#ff9800',
    color: '#000000',
    chipColor: 'warning',
    borderColor: '#f57c00'
  },
  'SHIPPED': {
    background: '#607d8b',
    color: '#ffffff',
    chipColor: 'default',
    borderColor: '#455a64'
  }
};

// Status Colors for Repack Dashboard (subset of above)
export const REPACK_STATUS_COLORS = {
  'REPACK-OUT': {
    background: '#ed6c02',
    color: '#ffffff',
    chipColor: 'warning'
  },
  'RE-PRINTING': {
    background: '#9c27b0',
    color: '#ffffff',
    chipColor: 'secondary'
  },
  'RE-PROCESS': {
    background: '#d32f2f',
    color: '#ffffff',
    chipColor: 'error'
  },
  'ONLINE MIX': {
    background: '#00897b',
    color: '#ffffff',
    chipColor: 'info'
  }
};

// Shift Options
export const SHIFT_OPTIONS = [
  'DAY',
  'NIGHT'
];

// Product Options (legacy - use DROPDOWN_OPTIONS.js instead)
export const PRODUCT_OPTIONS = [];

// Grade Options (legacy - use DROPDOWN_OPTIONS.js instead)
export const GRADE_OPTIONS = [];

// Brand Options (legacy - use DROPDOWN_OPTIONS.js instead)
export const BRAND_OPTIONS = [];

// Pack Size Options (legacy - use DROPDOWN_OPTIONS.js instead)
export const PACK_SIZE_OPTIONS = [];

// Pack Style Options
export const PACK_STYLE_OPTIONS = [
  'FINAL',
  'FBB',
  'PBB',
  'BULK'
];

// Helper function to check user permission
export const hasPermission = (user, permission) => {
  if (!user || !user.role) return false;
  
  const rolePermissions = ROLE_PERMISSIONS[user.role];
  if (!rolePermissions) return false;
  
  return rolePermissions[permission] === true;
};

// Helper function to check dashboard access
export const hasDashboardAccess = (userPermissions, dashboardId) => {
  return userPermissions && userPermissions[dashboardId] === true;
};

// Helper function to format date
export const formatDate = (dateString, format = DATE_FORMAT) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  if (format === DATETIME_FORMAT) {
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }
  
  return date.toISOString().split('T')[0];
};

// Helper function to get role label
export const getRoleLabel = (role) => {
  const labels = {
    admin: 'Admin',
    incharge: 'Incharge',
    supervisor: 'Supervisor',
    factory_head: 'Factory Head',
    factory_manager: 'Factory Manager',
    department_head: 'Department Head',
    managing_director: 'Managing Director',
    viewer: 'Viewer/Others'
  };
  
  return labels[role] || role;
};

// Helper function to get status color for Repack Dashboard
export const getRepackStatusColor = (status) => {
  return REPACK_STATUS_COLORS[status] || REPACK_STATUS_COLORS['REPACK-OUT'];
};

// Helper function to get status color for Daily Inventory
export const getDailyInventoryStatusColor = (status) => {
  return DAILY_INVENTORY_STATUS_COLORS[status] || DAILY_INVENTORY_STATUS_COLORS['PRODUCED'];
};

// Helper function to get status badge style
export const getStatusBadgeStyle = (status) => {
  const colorConfig = DAILY_INVENTORY_STATUS_COLORS[status];
  if (colorConfig) {
    return {
      backgroundColor: colorConfig.background,
      color: colorConfig.color,
      padding: '4px 12px',
      borderRadius: '4px',
      fontWeight: 600,
      fontSize: '0.75rem',
      display: 'inline-block'
    };
  }
  return {
    backgroundColor: '#9e9e9e',
    color: '#ffffff',
    padding: '4px 12px',
    borderRadius: '4px',
    fontWeight: 600,
    fontSize: '0.75rem',
    display: 'inline-block'
  };
};

// Helper function to get row style based on status
export const getStatusRowStyle = (status) => {
  const colorConfig = DAILY_INVENTORY_STATUS_COLORS[status];
  if (colorConfig) {
    return {
      borderLeft: `4px solid ${colorConfig.borderColor || colorConfig.background}`,
    };
  }
  return {};
};

// Export base URL for other components
export { API_BASE_URL };

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  USER_ROLES,
  ROLE_PERMISSIONS,
  DEFAULT_DASHBOARD_PERMISSIONS,
  APPROVAL_PRIORITY,
  APPROVAL_STATUS,
  ACTION_TYPES,
  APP_SETTINGS,
  DATE_FORMAT,
  DATETIME_FORMAT,
  EXPORT_TYPES,
  STATUS_OPTIONS,
  ADD_ENTRY_STATUS_OPTIONS,
  REPACK_DASHBOARD_STATUSES,
  CHANGE_STATUS_OPTIONS,
  DAILY_INVENTORY_STATUS_COLORS,
  REPACK_STATUS_COLORS,
  SHIFT_OPTIONS,
  PRODUCT_OPTIONS,
  GRADE_OPTIONS,
  BRAND_OPTIONS,
  PACK_SIZE_OPTIONS,
  PACK_STYLE_OPTIONS,
  hasPermission,
  hasDashboardAccess,
  formatDate,
  getRoleLabel,
  getRepackStatusColor,
  getDailyInventoryStatusColor,
  getStatusBadgeStyle,
  getStatusRowStyle
};